//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import instance from '../assets/js/instance'
import { Toast } from 'vant'

export default {
  data () {
    return {
      value: '',
      type: 2,
      page: 1,
      list: [],
      loading: true,
      finished: true,
    }
  },
  computed: {
    options () {
      return this.$t('search')
    },
    path () {
      return this.$store.getters.getPath
    }
  },
  methods: {
    onSearch () {
      this.showToast()
      this.page = 1
      this.list = []
      if (this.type === 1) {
        this.getBrandList()
      } else {
        this.getProductList()
      }
    },

    getBrandList () {
      this.loading = true
      instance.get(`/api/index/getBrands?brand_name=${this.value}&p=${this.page}`).then(res => {
        let data = res.data
        if (data.code === 0) {
          let list = data.data.list
          this.finished = this.list.length !== 10
          this.list = list.concat(this.list)
          
        }
        this.loading = false
        Toast.clear()
      }).catch(e => {
        this.loading = false
        Toast.clear()
        console.log(e)
      })
    },

    getProductList () {
      this.loading = true
      instance.get(`/api/goods/getGoods?name=${this.value}&p=${this.page}`).then(res => {
        let data = res.data
        if (data.code === 0) {
          let list = data.data.list
          this.finished = this.list.length !== 10
          this.list = list.concat(this.list)
        }
        this.loading = false
        Toast.clear()
      }).catch(e => {
        this.loading = false
        Toast.clear()
        console.log(e)
      })
    },


    onLoad () {
      this.page += 1
      if (this.type === 1) {
        this.getBrandList()
      } else {
        this.getProductList()
      }
    },

    cancel () {
      this.$router.go(-1)
    },

    showToast () {
      Toast.loading({
        duration: 0,
        mask: true,
        message: this.options.loading
      })
    }
  },
  
  mounted () {
    let type = 2
    if (this.$route.query.type) {
      type = this.$route.query.type
    }
    this.type = ~~type
  }
}
